import { Shadow } from '@genial/components';
import { Box, IBoxProps } from 'native-base';
import React from 'react';

interface ContainerProps extends IBoxProps {
  children: React.ReactNode;
}

export const Container: React.FC<ContainerProps> = ({ children, ...rest }) => {
  return (
    <Box maxH="490px" flex={1} maxW="360px" position="absolute" bottom={10} right={18} {...rest}>
      <Shadow level={5} borderRadius={rest.borderRadius}>
        {children}
      </Shadow>
    </Box>
  );
};
